<template>
    <div class="selectContractItem">
        <el-dialog title="选择合同信息" width="80%" top="10vh" :visible.sync="ContractItemDialog"
                   :close-on-click-modal="$root.dialogAutoClose" :close-on-press-escape="$root.dialogAutoClose">
            <el-form :inline="true" :model="formLine" style="position: relative;">
                <el-form-item label="合同名称：" class="noMarginBottom">
                    <el-input v-model.trim="formLine.contactName" size="mini" class="minWidth" placeholder="合同名称">
                    </el-input>
                </el-form-item>
                <el-form-item label="合同编号：" class="noMarginBottom">
                    <el-input v-model.trim="formLine.contactCode" size="mini" class="minWidth" placeholder="合同编号">
                    </el-input>
                </el-form-item>
                <!-- <el-form-item label="供应商：" class="noMarginBottom">
                    <el-input v-model.trim="formLine.supplierName" size="mini" class="minWidth" placeholder="供应商">
                    </el-input>
                </el-form-item> -->
                <el-form-item label="项目：" class="noMarginBottom">
                    <el-input v-model.trim="formLine.projectName" size="mini" class="minWidth" placeholder="项目">
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" size="mini" @click="seachContractItem()">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                      tooltip-effect="light" size="mini" highlight-current-row style="width: 100%"
                      @selection-change="handleSelectionChange" @current-change="chooseChange"
                      ref="Table">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="contactName" label="合同名称"/>
                <el-table-column prop="contactCode" width="" label="合同编号"/>
                <!-- <el-table-column prop="supplierName" width="250px" label="供应商名称"/> -->
                <el-table-column prop="companyName" width="" label="项目"/>
            </el-table>
            <div style="text-align: right;padding: 20px 0">
                <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange"
                               :current-page="this.formLine.pageNumber" :page-sizes="$root.pageSizesArr" :page-size="10"
                               layout="total, sizes, prev, pager, next, jumper" :total="dataCount">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="ContractItemDialog = false">取 消</el-button>
                <el-button type="primary" @click="confirmContractItem">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.component('contractDialog', {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        return {
            ContractItemDialog: false,
            formLine: {
                contactName: '',
                pageFlag: 1,
                pageNumber: 1,
                pageSize: 10,
            },
            tableData: [],
            dataCount: 0,

            multipleSelection: []
        }
    },
    //方法集合
    methods: {
        seachContractItem() {
            this.formLine.pageNumber = 1;
            this.getData();
        },
        handleSelectionChange(val) {
            if (val.length > 1) {
                this.$refs.Table.clearSelection()
                this.$refs.Table.toggleRowSelection(val.pop())
            }
            this.multipleSelection = val;
        },
        chooseChange(val) {
            this.$refs.Table.toggleRowSelection(val)
        },
        confirmContractItem() {
            debugger
            if (this.multipleSelection.length == 0) {
                this.$alert('请选择合同', {
                    type: 'warning'
                });
                return;
            }
            this.ContractItemDialog = false;
            this.$emit('callback', this.multipleSelection[0]);
        },
        handlePageChange(val) {
            let that = this;
            that.formLine.pageNumber = val;
            that.getData();
        },
        handleSizeChange(val) {
            let that = this;
            that.formLine.pageSize = val;
            that.getData();
        },
        getData() {
            let that = this;
            that.$root.postHttp('/v1/sContact/searchList', that.formLine, function (res) {
                that.tableData = res.data.data.list;
                that.dataCount = res.data.data.count;
            });
        },
        show() {
            this.ContractItemDialog = true;
            this.getData();
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
})
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类

@import '../../../assets/_var.scss';

.selectContractItem /deep/ {
    .el-dialog__body {
        padding: 10px 15px !important;
        color: #606266;
        line-height: 24px;
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/components/contractDialog.vue